/* Snackstalgia mini-cart: server-rendered drawer, refreshed through the Section Rendering API */
(function () {
  'use strict';
  if (window.SnackCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;
  var busy = false;
  var qaProduct = null;
  var qaSel = [];

  function drawer() { return document.querySelector('[data-cd]'); }
  function panel() { return document.querySelector('[data-cd-panel]'); }
  function msg(t) { var m = document.querySelector('[data-cd-msg]'); if (m) m.textContent = t || ''; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function setCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function open() {
    var d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-open');
    window.setTimeout(function () { var p = panel(); if (p) p.focus(); }, 30);
    return true;
  }
  function close() {
    var d = drawer(); if (!d) return;
    closeQuick();
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-open');
    msg('');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function pctOf(scope) {
    var b = scope.querySelector('.cd__bar');
    return b ? (parseInt(b.getAttribute('aria-valuenow'), 10) || 0) : null;
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd]');
    var cur = drawer();
    if (!fresh || !cur) return;
    var wasDone = !!cur.querySelector('.cd__ship.is-done');
    var oldPct = pctOf(cur);
    var p = cur.querySelector('[data-cd-panel]');
    var np = fresh.querySelector('[data-cd-panel]');
    var scroller = cur.querySelector('[data-cd-body]');
    var top = scroller ? scroller.scrollTop : 0;
    p.innerHTML = np.innerHTML;
    cur.setAttribute('data-count', fresh.getAttribute('data-count'));
    var nb = cur.querySelector('[data-cd-body]');
    if (nb) nb.scrollTop = top;
    setCounts(fresh.getAttribute('data-count'));

    var ship = cur.querySelector('.cd__ship');
    if (ship) {
      var fill = ship.querySelector('.cd__bar i');
      var truck = ship.querySelector('.cd__truck');
      var newPct = pctOf(cur);
      var from = oldPct === null ? 0 : oldPct;
      if (fill && truck && from !== newPct) {
        fill.style.width = from + '%';
        truck.style.left = from + '%';
        void fill.offsetWidth;
        fill.style.width = newPct + '%';
        truck.style.left = newPct + '%';
      }
      if (ship.classList.contains('is-done') && !wasDone) ship.classList.add('is-celebrate');
    }
  }

  function refresh() {
    return fetch(root + '?sections=cart-drawer&t=' + Date.now(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { swap(j['cart-drawer']); });
  }

  function setBusy(on) { busy = on; var d = drawer(); if (d) d.classList.toggle('is-busy', on); }

  function post(url, data) {
    setBusy(true);
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        var err = !res.ok ? (res.j && (res.j.description || res.j.message) || 'Something went wrong. Please try again.') : '';
        return refresh().then(function () { if (err) msg(err); return res.ok; });
      })
      .catch(function () { msg('Could not update your cart. Please try again.'); return false; })
      .then(function (ok) { setBusy(false); return ok; });
  }

  function change(line, qty) { msg(''); return post('cart/change.js', { line: line, quantity: Math.max(0, qty) }); }

  function saveGift(line, box) {
    var props = {};
    box.querySelectorAll('[data-keep]').forEach(function (i) { props[i.getAttribute('data-keep')] = i.value; });
    box.querySelectorAll('[data-gf]').forEach(function (i) { props[i.getAttribute('data-gf')] = i.value; });
    var li = box.closest('[data-cd-line]');
    msg('');
    return post('cart/change.js', { line: line, quantity: parseInt(li.getAttribute('data-qty'), 10) || 1, properties: props });
  }

  /* ---------- Quick choose window (variants without leaving the cart) ---------- */
  function qaWrap() {
    var q = document.querySelector('[data-cd-qa]');
    if (q) return q;
    q = document.createElement('div');
    q.className = 'cd__qa';
    q.setAttribute('data-cd-qa', '');
    q.hidden = true;
    q.innerHTML = '<div class="cd__qa-scrim" data-cd-qa-close></div><div class="cd__qa-box" role="dialog" aria-modal="true" aria-label="Choose an option" tabindex="-1"></div>';
    drawer().appendChild(q);
    return q;
  }
  function money(c) {
    var d = drawer();
    var pre = d ? d.getAttribute('data-prefix') || '' : '';
    var v = c / 100;
    return pre + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function variantFor() {
    if (!qaProduct) return null;
    return qaProduct.variants.filter(function (v) {
      return qaSel.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  }
  function qaRender() {
    var box = qaWrap().querySelector('.cd__qa-box');
    var p = qaProduct;
    var html = '<button class="cd__qa-x" type="button" data-cd-qa-close aria-label="Close"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    html += '<div class="cd__qa-head"><img data-qa-img alt="" src=""><div><h3>' + esc(p.title) + '</h3><p class="cd__qa-price" data-qa-price></p></div></div>';
    p.options.forEach(function (o, i) {
      html += '<fieldset><legend>' + esc(o.name) + '</legend><div class="cd__qa-opts">';
      o.values.forEach(function (val) {
        html += '<label><input type="radio" name="qa-o' + i + '" value="' + esc(val) + '" data-qa-opt="' + i + '"' + (qaSel[i] === val ? ' checked' : '') + '><span>' + esc(val) + '</span></label>';
      });
      html += '</div></fieldset>';
    });
    html += '<button class="cd__qa-add" type="button" data-cd-qa-add>Add to cart</button>';
    box.innerHTML = html;
    qaUpdate();
  }
  function qaUpdate() {
    var box = qaWrap().querySelector('.cd__qa-box');
    var v = variantFor();
    var price = box.querySelector('[data-qa-price]');
    var btn = box.querySelector('[data-cd-qa-add]');
    var img = box.querySelector('[data-qa-img]');
    var src = (v && v.featured_image && v.featured_image.src) || qaProduct.featured_image || '';
    if (img && src) img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    if (!v) { price.textContent = ''; btn.disabled = true; btn.textContent = 'Unavailable'; return; }
    price.textContent = money(v.price);
    btn.disabled = !v.available;
    btn.textContent = v.available ? 'Add to cart' : 'Sold out';
  }
  function openQuick(handle, trigger) {
    msg('');
    fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qaProduct = p;
        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        qaSel = first.options.slice();
        qaWrap().hidden = false;
        qaRender();
        var b = qaWrap().querySelector('.cd__qa-box');
        if (b) b.focus();
      })
      .catch(function () { msg('Could not load the options. Please try again.'); });
  }
  function closeQuick() {
    var q = document.querySelector('[data-cd-qa]');
    if (q && !q.hidden) { q.hidden = true; qaProduct = null; }
  }
  function qaOpen() { var q = document.querySelector('[data-cd-qa]'); return !!(q && !q.hidden); }

  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-qa-opt]');
    if (!r) return;
    qaSel[parseInt(r.getAttribute('data-qa-opt'), 10)] = r.value;
    qaUpdate();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var cartBtn = t.closest('.cart-btn');
    if (cartBtn && drawer() && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); refresh().then(open, open); return; }
    if (t.closest('[data-cd-qa-close]')) { closeQuick(); return; }
    var qa = t.closest('[data-cd-qa-add]');
    if (qa && !busy) {
      var v = variantFor();
      if (v && v.available) { post('cart/add.js', { items: [{ id: v.id, quantity: 1 }] }).then(function (ok) { if (ok) closeQuick(); }); }
      return;
    }
    if (t.closest('[data-cd-close]')) { close(); return; }
    var ch = t.closest('[data-cd-choose]');
    if (ch && !busy) { openQuick(ch.getAttribute('data-cd-choose'), ch); return; }
    var q = t.closest('[data-cd-qty]');
    if (q && !busy) { change(parseInt(q.getAttribute('data-cd-qty'), 10), parseInt(q.getAttribute('data-q'), 10)); return; }
    var rm = t.closest('[data-cd-remove]');
    if (rm && !busy) { change(parseInt(rm.getAttribute('data-cd-remove'), 10), 0); return; }
    var sv = t.closest('[data-cd-save]');
    if (sv && !busy) { saveGift(parseInt(sv.getAttribute('data-cd-save'), 10), sv.closest('.cdl__fields')); return; }
    var add = t.closest('[data-cd-add]');
    if (add && !busy) {
      msg('');
      post('cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-cd-add'), 10), quantity: 1 }] });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { if (qaOpen()) closeQuick(); else close(); return; }
    if (e.key !== 'Tab') return;
    var scope = qaOpen() ? d.querySelector('.cd__qa-box') : d;
    var f = Array.prototype.slice.call(scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, summary')).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel() || document.activeElement === scope)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.SnackCart = { open: open, close: close, refresh: refresh, openAfterAdd: function () { return refresh().then(open, open); } };
})();